import { GzRmTopIdentityRisksImpactWidgetWebComponent } from './component/GzRmTopIdentityRisksImpactWidgetWebComponent';

export { GzRmTopIdentityRisksImpactWidgetWebComponent };
